import React from 'react';
import { Box, Button } from '@drivekyte/web-components';
import SearchBox from '@/components/search-box/search-box';
import useSearch from '@/hooks/use-search';
import useTranslation from '@/hooks/use-translation';
import AppStoreRating from '../app-store-rating';

const WhereAndWhen = () => {
  const { t } = useTranslation('pages.welcome-page.search');
  const {
    isFormValid,
    isLoadingTimeSlots,
    isFetchingQuotes,
    onSubmitWithQuotes,
  } = useSearch({ disableTimeslotFetching: true });

  return (
    <SearchBox calendarTestID="responsive-landing-page-calendar">
      <Box marginTop="small" marginBottom="xSmall">
        <Button
          testID="responsive-landing-page-search-cta"
          fullWidth
          loading={isFetchingQuotes || isLoadingTimeSlots}
          disabled={!isFormValid}
          onPress={onSubmitWithQuotes}
        >
          {t('submit')}
        </Button>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        marginBottom="xxLarge"
      >
        <AppStoreRating />
      </Box>
    </SearchBox>
  );
};

export default WhereAndWhen;
